import React, { Component } from 'react';

import './index.css';

import apiurl from './apiurl';

import axios from 'axios';

import RejestrForm1 from './RejestrForm1';













export default class Rejestr extends React.Component {

  constructor() {

    super();    

    this.state = {

      token: sessionStorage.getItem('token'),

      component: 1

    }

    this.getRejestr();

  }

  



  getRejestr = () => {

    axios

      .get(apiurl+"api/v2/RejestrRokObr ", { headers: { 'Authorization' : "Bearer " + this.state.token }})

      .then(response => {
        const data = response.data.reverse();
        this.setState({ rejestrData: data })

        const wybrany = response.data.findIndex(elem => elem.rok.toString() === this.props.rok);

        this.setState({ idxWyb: wybrany, rok: this.props.rok})

      })

      .catch(error => {console.log(error)});

  }

  





    

render() {

const { rejestrData, idxWyb, component, rok } = this.state;

return (

<React.Fragment>

<div class="container-fluid overflow-auto">

{component === 1 ? (<div className='d-flex flex-row w-100 h-100 p-5' style={{ maxHeight: '90vh'}}>

  <div className='d-flex card flex-row p-2' >

    <div className='d-flex flex-column scroll' style={{ overflow: 'auto', minWidth: '110px'}}>

      <div className='w-100 p-2'>

        <ul class="list-group text-nowrap">

        {rejestrData ? (rejestrData.map((data, idx) => { return (<li class={idxWyb === idx ? "list-group-item pointer active" : "list-group-item pointer"} onClick={() => (this.setState({ idxWyb: idx, rok: data.rok}))} style={{ minWidth: '70px'}} key={idx}>{data.rok}</li>)})) : null }

        </ul>

      </div>

    </div>

    <div className='d-flex flex-column scroll p-1' style={{ overflow: 'auto'}}>

        <ul class="list-group">

        {idxWyb ? (rejestrData[idxWyb].rejestr.map((data, idx) => { return (<li class="list-group-item pointer"  onClick={() => (this.setState({ kodJedn : data.kodJedn, component: 2}))}>{data.nazwa}</li>)})) : null }

        </ul>

    </div>

  </div>



</div>) : null }



{component === 2 ? (<div className='d-flex flex-row w-100 h-100 p-5' style={{ maxHeight: '90vh'}}><RejestrForm1  rok={this.state.rok} kodJedn={this.state.kodJedn} /></div>) : null }



</div>

</React.Fragment>

);

}

}

